// External
import React from "react";
import _ from "lodash";

// Design system
import { EmptyState } from "@toddle-edu/ds-web";
import { NoDataIllustration } from "@toddle-edu/ds-theme";
import FeedListv2 from "AppComponents/FeedListv2";

// Relative
import {
  getTemplateVersionHistoryColumnList,
  getTemplateVersionHistoryFeedData,
} from "../../modules/TemplateLogsModalUtils";
import DownloadTableData from "../../../DownloadTableData/DownloadTableData";

// Styles
import classes from "./TemplateVersionHistoryTable.scss";

const styles = {
  emptyStateSubtitleStyle: {
    maxWidth: "448px",
  },
};

const TemplateVersionHistoryTable = ({
  templateVersionHistory,
  onRowClick,
}) => {
  const columnList = getTemplateVersionHistoryColumnList();
  const feedData = getTemplateVersionHistoryFeedData({
    data: templateVersionHistory,
  });

  if (_.isEmpty(feedData)) {
    return (
      <div className={classes.emptyStateContainer}>
        <EmptyState
          title="No template version history found"
          subtitle="There are no template version history recorded for this progress report template yet"
          subtitleStyle={styles.emptyStateSubtitleStyle}
          illustration={NoDataIllustration}
        />
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h1>Template Version History</h1>
        <DownloadTableData
          feedData={feedData}
          columnList={columnList}
          fileName="template_version_history_logs"
        />
      </div>
      <div className={classes.tableContainer}>
        <FeedListv2
          columnList={columnList}
          feedData={feedData}
          enableStickyHeader={true}
          headerTheme="subtle"
          showBorder={true}
          onItemClick={onRowClick}
        />
      </div>
    </div>
  );
};

export default TemplateVersionHistoryTable;
